<portal-sub-nav [force]="force" (visibleChanged)="loadTrunk($event)" route="enterprise-trunk">
  <div [class.d-none]="loading$ | async">
    @if (trunk$ | async; as trunk) {
      <portal-menu-context
        [description]="trunk.description"
        [heading]="'trunk.breadcrumbSwitcher.heading' | translate"
      >
        <ng-template>
          <portal-trunk-switcher [trunk]="trunk" [trunks]="typeaheadTrunks$ | async"></portal-trunk-switcher>
        </ng-template>
      </portal-menu-context>
    }

    <!-- Settings -->
    <portal-sub-nav-item route="enterprise-trunk-settings">
      <span *portalTransclude>{{ 'menu.trunk.settings' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Users -->
    <portal-sub-nav-item route="enterprise-trunk-users">
      <span *portalTransclude>{{ 'menu.trunk.users' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Number ranges -->
    <portal-sub-nav-item route="enterprise-trunk-number-ranges">
      <span *portalTransclude>{{ 'menu.trunk.numberRanges' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Features -->
    <portal-sub-nav-item route="enterprise-trunk-features">
      <span *portalTransclude>{{ 'menu.trunk.features' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Call-Barring -->
    <portal-sub-nav-item route="enterprise-trunk-call-barring">
      <span *portalTransclude>{{ 'menu.trunk.callBarring' | portalTranslate }}</span>
    </portal-sub-nav-item>
  </div>

  @if (loading$ | async) {
    <portal-menu-loading-indicator [withContext]="true"></portal-menu-loading-indicator>
  }
</portal-sub-nav>
